import { useState, useEffect, useCallback } from 'react';
import { breakpointValues } from './breakpointValues';
export const useIsBelowBreakpoint = (breakpoint) => {
    const breakpointValue = breakpointValues[breakpoint];
    const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(() => {
        if (typeof window === 'undefined')
            return false;
        return window.innerWidth < breakpointValue;
    });
    const handleResize = useCallback(() => {
        setIsBelowBreakpoint(window.innerWidth < breakpointValue);
    }, [breakpointValue]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    return isBelowBreakpoint;
};
